<template>
  <div v-if="error" class="error" style="color:#c00;margin-bottom:1rem;">{{ error }}</div>
  <div class="edit-user-container">
  <Header :title="isEditing ? 'Edit User' : 'New User'" :user="currentUser" />

    <div v-if="cameraOpen" class="camera-overlay">
/* camera overlay */
 .camera-overlay {
   position: fixed;
   inset: 0;
   background: rgba(0,0,0,0.6);
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 1000;
 }
      <div class="camera-modal" @click.stop>
  <video ref="videoEl" autoplay playsinline />
        <div class="action-btn-bar" style="margin-top:1rem;">
          <button type="button" @click="capturePhoto" class="action-btn construct-btn">Capture</button>
          <button type="button" @click="closeCamera" class="action-btn">Cancel</button>
        </div>
      </div>
    </div>

  <main class="page-main">
      <div style="display:flex;justify-content:center;margin-bottom:1.5rem;">
        <button type="button" class="avatar-btn" @click="openCamera" aria-label="Edit profile photo" style="width:200px;height:200px;">
          <div style="position:relative;width:200px;height:200px;">
            <img v-if="user.avatar_url" :src="user.avatar_url" alt="Profile" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;border-radius:50%;z-index:1;" />
            <img v-else-if="user.profileImageDataUrl" :src="user.profileImageDataUrl" alt="Profile" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;border-radius:50%;z-index:1;" />
            <img v-else src="/camera.png" alt="Add photo" style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:60px;height:60px;z-index:2;" />
            <span v-if="!user.avatar_url && !user.profileImageDataUrl" class="avatar-initials" style="position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:3rem;border-radius:50%;background:rgba(238,238,238,0.3);color:#fff;z-index:1;">{{ (user.name || 'U').charAt(0).toUpperCase() }}</span>
          </div>
        </button>
      </div>
      
      <!-- User Type Display -->
      <div style="display:flex;justify-content:center;margin-bottom:1.5rem;">
        <div style="text-align:center;">
          <div style="font-size:1.1rem;font-weight:600;color:#333;margin-bottom:0.25rem;">
            {{ user.name || 'New User' }}
          </div>
          <div style="font-size:0.95rem;color:#666;padding:0.25rem 0.75rem;background:#f5f5f5;border-radius:1rem;display:inline-block;">
            <span v-if="user.type">{{ formatUserType(user.type) }}</span>
            <span v-else style="font-style:italic;">No type set</span>
          </div>
          <div v-if="user.isAdmin || user.isAccount" style="margin-top:0.5rem;display:flex;gap:0.5rem;justify-content:center;flex-wrap:wrap;">
            <span v-if="user.isAdmin" style="font-size:0.85rem;color:#fff;background:#43a047;padding:0.15rem 0.5rem;border-radius:0.75rem;font-weight:500;">
              Admin
            </span>
            <span v-if="user.isAccount" style="font-size:0.85rem;color:#fff;background:#2196f3;padding:0.15rem 0.5rem;border-radius:0.75rem;font-weight:500;">
              Account Holder
            </span>
          </div>
        </div>
      </div>
      
      <form @submit.prevent="saveUser" class="user-form">
        <div class="form-group">
          <input
            id="name"
            name="name"
            v-model="user.name"
            type="text"
            required
            placeholder="Name"
            aria-label="Name"
          />
        </div>
        <div class="form-group">
          <input
            id="email"
            name="email"
            v-model="user.email"
            type="email"
            :required="!!user.isAccount"
            placeholder="Email"
            aria-label="Email"
          />
          <small v-if="user.isAccount" class="form-hint">Email is required for account holders</small>
        </div>
        <div v-if="isAdmin" class="form-group">
          <select id="type" v-model="user.type" name="type" required>
            <option value="parent">Parent</option>
            <option value="child">Child</option>
          </select>
        </div>
        <div class="form-group">
          <input
            id="password"
            name="password"
            v-model="user.password"
            type="password"
            :required="!isEditing || passwordChanged"
            placeholder="Password"
            aria-label="Password"
          />
          <small v-if="isEditing" class="form-hint">Leave blank to keep current password</small>
        </div>
        <div v-if="isAdmin" class="form-group" style="display:flex;align-items:center;gap:1rem;">
          <label style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
            <input type="checkbox" v-model="user.isAccount" id="isAccount" />
            Account Holder
          </label>
          <label style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
            <input type="checkbox" v-model="user.isAdmin" id="isAdmin" />
            Admin
          </label>
        </div>

  <div class="action-btn-bar">
          <button type="button" @click="goBack" class="action-btn">Cancel</button>
          <button type="submit" :disabled="saving" class="action-btn construct-btn">
            {{ saving ? 'Saving...' : 'Save' }}
          </button>
          <button v-if="isEditing" type="button" @click="deleteUserConfirm" class="action-btn destruct-btn">Delete</button>
        </div>
      </form>
    </main>
  </div>
</template>

<script setup lang="ts">
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
const error = ref('');
// Remove SHA-256 import since server handles hashing
// import { sha256 } from 'js-sha256';

const deleteUserConfirm = async () => {
  if (!isEditing.value) return;
  if (confirm('Are you sure you want to delete this user? This cannot be undone.')) {
    const id = route.params.id as string;
    try {
      await dbService.deleteUser(id);
      router.push('/users');
    } catch (err) {
      alert('Failed to delete user');
    }
  }
}
const goProfile = () => {
  router.push({ name: 'edit-user', params: { id: currentUser.value?.id } })
}
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Header from '../components/Header.vue'
import { dbService, type User } from '../services/database'
// ...existing code...

const router = useRouter()
const route = useRoute()

const currentUser = ref<User | null>(null)
const parentCreating = ref(false)
const families = ref<Array<{id:string,name:string}>>([])
const members = ref<User[]>([])

const isEditing = computed(() => !!route.params.id)
const saving = ref(false)
const passwordChanged = ref(false)
const isAdmin = computed(() => currentUser.value?.isAdmin)

const user = reactive({
  name: '',
  email: '',
  password: '',
  type: 'parent' as 'parent' | 'child',
  profileImageDataUrl: null as string | null,
  avatar_url: null as string | null,
  isAccount: false,
  isAdmin: false,
  account_id: ''
})

// Helper function to format user type for display
const formatUserType = (type: string) => {
  switch (type?.toLowerCase()) {
    case 'parent':
      return 'Parent'
    case 'child':
      return 'Child'
    case 'admin':
      return 'Administrator'
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Unknown'
  }
}

// Upload avatar image to Cloudinary and save URL

const goDashboard = () => {
  router.push('/dashboard')
}

const goBack = () => {
  router.push('/users')
}

const editMember = (id: string) => {
  router.push({ name: 'edit-user', params: { id } })
}

const cameraOpen = ref(false)
const videoEl = ref<HTMLVideoElement | null>(null)
let mediaStream: MediaStream | null = null

const openCamera = async () => {
  try {
    cameraOpen.value = true
    mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
    if (videoEl.value) {
      // @ts-ignore
      videoEl.value.srcObject = mediaStream
    }
  } catch (err) {
    alert('Unable to access camera')
    cameraOpen.value = false
  }
}

const stopCamera = () => {
  if (mediaStream) {
    mediaStream.getTracks().forEach(t => t.stop())
    mediaStream = null
  }
  if (videoEl.value) {
    // @ts-ignore
    videoEl.value.srcObject = null
  }
}

const closeCamera = () => {
  stopCamera()
  cameraOpen.value = false
}

// Upload avatar image to Cloudinary and save URL
const uploadAvatarToCloud = async (dataUrl: string) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/upload`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image: dataUrl })
    })
    if (!res.ok) throw new Error('Failed to upload avatar')
    const { url } = await res.json()
    user.avatar_url = url
  } catch (err) {
    error.value = 'Avatar upload failed'
  }
}

const capturePhoto = () => {
  const video = videoEl.value
  if (!video) return
  const canvas = document.createElement('canvas')
  // get actual video dimensions
  const srcWidth = (video as any).videoWidth || 640
  const srcHeight = (video as any).videoHeight || 480
  
  // downscale to max 640px on longest dimension
  const maxDim = 640
  let targetWidth = srcWidth
  let targetHeight = srcHeight
  if (srcWidth > maxDim || srcHeight > maxDim) {
    if (srcWidth > srcHeight) {
      targetWidth = maxDim
      targetHeight = Math.round((srcHeight / srcWidth) * maxDim)
    } else {
      targetHeight = maxDim
      targetWidth = Math.round((srcWidth / srcHeight) * maxDim)
    }
  }
  
  canvas.width = targetWidth
  canvas.height = targetHeight
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  ctx.drawImage(video, 0, 0, targetWidth, targetHeight)
  const dataUrl = canvas.toDataURL('image/jpeg', 0.85)
  ;(user as any).profileImageDataUrl = dataUrl
  uploadAvatarToCloud(dataUrl)
  closeCamera()
}

const saveUser = async () => {
  saving.value = true;
  error.value = '';
  try {
    let updatedUser: User | null = null;
    const id = route.params.id as string;
    const payload: any = {
      name: user.name,
      email: user.email,
      type: user.type,
      avatar_url: user.avatar_url || null,
      isAccount: user.isAccount,
      isAdmin: user.isAdmin,
      account_id: user.account_id || (route.query.familyOwner ? String(route.query.familyOwner) : undefined)
    };
    
    // Send plain password - let server handle bcrypt hashing
    if (user.password && user.password.trim()) {
      payload.password = user.password; // Changed from password_hash to password
    }
    // If creating a child, set account_id to parent's ID
    if (!isEditing.value && user.type === 'child') {
      // Prefer route.query.familyOwner, fallback to currentUser
      payload.account_id = route.query.familyOwner ? String(route.query.familyOwner) : (currentUser.value?.id || null);
    }
    if (isEditing.value) {
      updatedUser = await dbService.updateUser(id, payload);
    } else {
      updatedUser = await dbService.addUser(payload);
    }
    if (updatedUser && currentUser.value && updatedUser.id === currentUser.value.id) {
      // Update session with new user data instead of using sessionStorage
      // The session will be validated on next page load via cookies
    }
    router.push('/dashboard');
  } catch (err) {
    console.error('Failed to save user:', err);
    error.value = err instanceof Error ? err.message : 'Failed to save user';
  } finally {
    saving.value = false;
  }
}

// ...existing code...
const loadUser = async () => {
  if (!isEditing.value) return;
  try {
    const id = route.params.id as string;
    const existingUser = await dbService.getUser(id);
  user.name = existingUser.name || '';
  user.email = existingUser.email || '';
  user.type = existingUser.type || 'parent';
  user.isAccount = !!existingUser.isAccount;
  user.isAdmin = !!existingUser.isAdmin;
  (user as any).profileImageDataUrl = existingUser.profileImageDataUrl || null;
  user.avatar_url = existingUser.avatar_url || null;
  user.password = '';
  user.account_id = existingUser.account_id || '';
  } catch (error) {
    console.error('Failed to load user:', error);
  }
}

const loadFamilies = async () => {
  try {
    const all = await dbService.getUsers()
    // Get account holders (users with isAccount=true) to act as family heads
    families.value = all.filter((u: any) => u.isAccount).map((f: any) => ({ id: f.id, name: f.name }))
  } catch (error) {
    console.error('Failed to load account holders:', error)
  }
}

const loadMembers = async () => {
  // Load family members for account holders
  try {
    if (!user.account_id && !isEditing.value) {
      members.value = []
      return
    }
    const all = await dbService.getUsers()
    // Members are users whose account_id matches this user's account_id
    const targetAccountId = user.account_id || (isEditing.value ? user.account_id : currentUser.value?.id)
    members.value = all.filter((u: any) => (u.account_id || null) === targetAccountId && u.id !== user.account_id)
  } catch (error) {
    console.error('Failed to load family members:', error)
    members.value = []
  }
}

onMounted(async () => {
  // Load user data from sessionStorage (no session validation needed)
  try {
    const userStr = sessionStorage.getItem('currentUser');
    if (userStr) {
      currentUser.value = JSON.parse(userStr);
      console.log('EditUser: User loaded from sessionStorage:', currentUser.value);
    } else {
      console.log('EditUser: No user data in sessionStorage');
    }
  } catch (error) {
    console.error('EditUser: Error parsing user data from sessionStorage:', error);
  }
  
  console.log('EditUser: Loading without session validation');

  // support creating a family via query ?type=family
  // family type removed

  // If creating a new user and familyOwner is present in route query, set it
  if (!isEditing.value && route.query.familyOwner) {
    user.account_id = String(route.query.familyOwner)
    if (route.query.type === 'parent' || route.query.type === 'child') {
      user.type = route.query.type as 'parent' | 'child';
    }
  }
  // if creating new and the logged-in user is a parent (not admin), prefill family and limit options
  if (!isEditing.value && currentUser.value && currentUser.value.type === 'parent') {
    parentCreating.value = true
    // default to child when adding to family
    user.type = 'child'
  }

  await loadFamilies()
  await loadUser()
  // load members for family pages
  await loadMembers()
})

// re-load members when the account_id changes
watch(() => user.account_id, async () => {
  await loadMembers()
})
</script>

<style scoped>
.edit-user-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-header {
  background: white;
  padding: 1rem 2rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-header h1 {
  margin: 0;
  color: #333;
}


.member-edit-btn {
  background: transparent;
  border: 1px solid #ccc;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
}

.member-edit-btn:hover {
  background: #f0f0f0;
}

/* header logo positioning (match other pages) */
.edit-user-container .page-header {
  position: relative;
  padding-left: 4.75rem;
}

.logo-btn {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo-btn img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  display: block;
}

/* avatar button */
.avatar-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background: #fafafa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}
.avatar-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.avatar-initials {
  font-weight: 600;
  color: #666;
}

/* camera overlay */
.camera-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
  .camera-modal {
    background: #fff;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    position: absolute;
    left: 2rem;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    max-width: calc(100vw - 4rem);
    box-sizing: border-box;
    z-index: 1001;
  }

  .camera-modal video {
    width: 300px;
    height: 300px;
    border-radius: 50%;
    object-fit: cover;
    background: #000;
    display: block;
    margin: 0 auto;
  }
</style>